import React, { useEffect, useState } from 'react'
import { getHighlight } from '../Service/Api';
import { Link } from 'react-router-dom'
const Highlights = () => {
  const [data,setData] = useState([]);
  const [loading,setLoading] = useState(true);
  const [error,setError] = useState(null);

    useEffect(() => {
          const fetchData = async  () => {
               try{
                  const response = await getHighlight();
                  setData(response);
               } catch(error) {
                 setError(error)
               } finally {
                 setLoading(false)
               }
          }
          fetchData();
    },[]);
    
  return (
    <>
      <div className="highlights">
      <img src="https://webapi.entab.info/api/image/TAFS/public/Images/highlighticn.png" className="img-fluid"/>
      <marquee onMouseOver={(event) => event.currentTarget.stop()}   onMouseOut={(event) => event.currentTarget.start()}>
      {data && data.length > 0 ? (data.map((item,index) =>(
        <p key={index} style={{color:'#000'}}> {item.title} {item.attachments && item.attachments[0] && ( <Link to={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank">  <i className="bi bi-paperclip"></i></Link> )} | </p>
           ))):null} 
             </marquee>
      </div>
    </>
  )
}

export default Highlights
